import React, { memo } from 'react';
import cn from 'classnames';
import capitalize from 'lodash/capitalize';

import { useDynamicSVGImport } from './useDynamicSVGImport';

import styles from './Icon.module.scss';

export type IconName =
  | 'edit'
  | 'chevron-left'
  | 'chevron-right'
  | 'cancel'
  | 'long-right-arrow'
  | 'right-arrow'
  | 'campaigns'
  | 'search'
  | 'societies'
  | 'vector'
  | 'new-campaign'
  | 'eye-open'
  | 'eye-close'
  | 'tick-mark'
  | 'chevron-down'
  | 'search'
  | 'filter'
  | 'reset'
  | 'percentage'
  | 'screen'
  | 'flying-letter'
  | 'messages'
  | 'huzzle'
  | 'huzzle.recruiter'
  | 'huzzle.society'
  | 'check-contained'
  | 'group'
  | 'calendar'
  | 'upload'
  | 'dashboard'
  | 'export'
  | 'success'
  | 'info'
  | 'warning'
  | 'error'
  | 'trash'
  | 'caution'
  | 'profile';

export type IconSize =
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'auto';

export interface IconProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  style?: Record<string, unknown>;
  /** name of the icon */
  iconName: IconName;
  /** size of the icon */
  size?: IconSize;
}

export const Icon: React.FC<IconProps> = memo(
  ({
    className = '', // custom class name
    style, // custom style
    iconName,
    size = 'medium',
  }: IconProps) => {
    const contentClassNames = cn(
      {
        [styles.Icon]: true,
        [`${styles[`IconSize${capitalize(size)}`]}`]: size,
      },
      className
    );

    const { SVGIcon } = useDynamicSVGImport(iconName);

    return (
      <div className={contentClassNames} style={style} data-testid="Icon">
        {SVGIcon !== null ? <SVGIcon /> : null}
      </div>
    );
  }
);

Icon.displayName = 'Icon';
